// extracted by mini-css-extract-plugin
export default {"container":"Uo-z","brandName":"Vo-z","productName":"Wo-z","productNamePdpEnhancements":"Xo-z","breakLongProductName":"Yo-z"};